import React, { useState } from 'react'

const AddBill = props => {
  const [desc, setDesc] = useState('')
  const [dueDate, setDueDate] = useState('')
  const [amount, setAmount] = useState('')
  const username = props.username

  const handleSubmit = e => {
    e.preventDefault()
    const newBill = {
      desc,
      dueDate,
      amount,
      username
    }
    props.handleBillAdded(newBill)
  }

  return (
    <div className='active-bill-container fade-to-black'>
      <div className='active-bill font150'>
        <form className='edit-bill mr ml mb' onSubmit={handleSubmit}>
          <label htmlFor='desc'>Description: </label>
          <input
            id='desc'
            className='text-center font100 mb'
            type='text'
            name='desc'
            value={desc}
            placeholder='Netflix'
            onChange={e => setDesc(e.target.value)}
          />
          <label htmlFor='dueDate'>Due Date: </label>
          <input
            id='dueDate'
            className='text-center font100 mb'
            type='text'
            name='dueDate'
            value={dueDate}
            placeholder='04/05/2020'
            onChange={e => setDueDate(e.target.value)}
          />
          <label htmlFor='amount'>Amount: </label>
          <input
            id='amount'
            className='text-center font100 mb'
            type='text'
            name='amount'
            value={amount}
            placeholder='$13'
            onChange={e => setAmount(e.target.value)}
          />
          <input className='button-1 mt font75' type='submit' value='Add' />
        </form>
        <p className='mt font50 pointer' onClick={() => props.close()}>
          Close
        </p>
      </div>
    </div>
  )
}

export default AddBill
